import React from 'react'
import { DropdownItem } from './styles'

export type AssigneeTab = 'users' | 'groups'

// Users / User groups tabs, for a dropdown that lists both kinds of assignee.
export const AssigneeTypeTabs = ({
  active,
  onChange,
}: {
  active: AssigneeTab
  onChange: (tab: AssigneeTab) => void
}): JSX.Element => (
  <div
    role="tablist"
    aria-label="Assignee type"
    style={{ display: 'flex', marginBottom: 8 }}
  >
    {(['users', 'groups'] as const).map((tab) => (
      <DropdownItem
        key={tab}
        role="tab"
        aria-selected={active === tab}
        style={{
          whiteSpace: 'nowrap',
          fontWeight: active === tab ? 600 : 400,
          borderBottom:
            active === tab ? '2px solid currentColor' : '2px solid transparent',
        }}
        onKeyDown={(e) => {
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            e.preventDefault()
            onChange(tab === 'users' ? 'groups' : 'users')
            const sibling =
              tab === 'users'
                ? e.currentTarget.nextElementSibling
                : e.currentTarget.previousElementSibling
            ;(sibling as HTMLButtonElement | null)?.focus()
          }
        }}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onChange(tab)
        }}
      >
        {tab === 'users' ? 'Users' : 'User groups'}
      </DropdownItem>
    ))}
  </div>
)
